export default __webpack_public_path__ + "static/media/spanish-icon.e4c4ded9.svg";